import { render, staticRenderFns } from "./DiscontinuanceInformation.vue?vue&type=template&id=36ca315d"
import script from "./DiscontinuanceInformation.vue?vue&type=script&lang=ts"
export * from "./DiscontinuanceInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports